import React from 'react';

const DeletePillarConnection = ({ flagVisiblePillar, dataConnectionPillar, deletePillarCoupling, deletePillarPonBox, deletePillarFob, deletePillarCable, id }) => {

  if (!flagVisiblePillar || dataConnectionPillar.length === 0) {
    return null;
  }

  return (
    <div style={{ justifyContent: 'center' }}>
      <label style={{ color: '#dfab01', display: flagVisiblePillar ? 'block' : 'none', fontSize: '18px' }}>Связи</label>

      {/* Муфта */}
      {dataConnectionPillar.some(item => item.couplingLocationId !== null) && (
        <div className='divStartEndCableModal' style={{ marginTop: '10px' }}>
          <img style={{ marginLeft: '10px', marginRight: '10px', width: '30px', height: '30px' }} src='./сoupling.png' alt='вектор' />
          <label style={{ color: '#dfab01', fontSize: '18px' }}>Муфта</label>
          <hr className='horizontalLine2Modal' />
          {dataConnectionPillar.map((item, index) => (
            item.couplingLocationId !== null && (
              <div className='divBodyConnectModal' key={index}>
                <span style={{ fontWeight: 'bold' }}>ID: {item.couplingLocationId}</span>
                <br />
                <span style={{ fontSize: '14px', color: '#202020' }}>Координаты: {item.couplingLatitude}, {item.couplingLongitude}</span>
                <br/>
                <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deletePillarCoupling(id, item.couplingLocationId)}> Удалить</button>  
              </div>
            )
          ))}
        </div>
      )}

      {/* Пон-бокс */}
      {dataConnectionPillar.some(item => item.ponBoxLocationId !== null) && (
        <div className='divStartEndCableModal' style={{ marginTop: '10px' }}>
          <img style={{ marginLeft: '10px', marginRight: '10px', width: '30px', height: '30px' }} src='./fob.png' alt='вектор' />
          <label style={{ color: '#dfab01', fontSize: '18px' }}>Пон-бокс</label>
          <hr className='horizontalLine2Modal' />
          {dataConnectionPillar.map((item, index) => (
            item.ponBoxLocationId !== null && (
              <div className='divBodyConnectModal' key={index}>
                <span style={{ fontWeight: 'bold' }}>ID: {item.ponBoxLocationId}</span>
                <br />
                <span style={{ fontSize: '14px', color: '#202020' }}>Координаты: {item.ponBoxLatitude}, {item.ponBoxLongitude}</span>
                <br/>
                <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deletePillarPonBox(id, item.ponBoxLocationId)}> Удалить</button>  
              </div>
            )
          ))}
        </div>
      )}

      {/* Фоб */}
      {dataConnectionPillar.some(item => item.fobLocationId !== null) && (
        <div className='divStartEndCableModal' style={{ marginTop: '10px' }}>
          <img style={{ marginLeft: '10px', marginRight: '10px', width: '30px', height: '30px' }} src='./fob.png' alt='вектор' />
          <label style={{ color: '#dfab01', fontSize: '18px' }}>Фоб</label>
          <hr className='horizontalLine2Modal' />
          {dataConnectionPillar.map((item, index) => (
            item.fobLocationId !== null && (
              <div className='divBodyConnectModal' key={index}>
                <span style={{ fontWeight: 'bold' }}>ID: {item.fobLocationId}</span>
                <br />
                <span style={{ fontSize: '14px', color: '#202020' }}>Координаты: {item.fobLatitude}, {item.fobLongitude}</span>
                <br/>
                <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deletePillarFob(id, item.fobLocationId)}> Удалить</button> 
              </div>
            )
          ))}
        </div>
      )}

      {/* Кабель */}
      {dataConnectionPillar.some(item => item.highwayLineId !== null) && (
        <div className='divStartEndCableModal' style={{ marginTop: '10px' }}>
          <img style={{ marginLeft: '10px', marginRight: '10px', width: '30px', height: '30px' }} src='./cable.png' alt='вектор' />
          <label style={{ color: '#dfab01', fontSize: '18px' }}>Кабель</label>
          <hr className='horizontalLine2Modal' />
          {dataConnectionPillar.map((item, index) => (
            item.highwayLineId !== null && (
              <div className='divBodyConnectModal' key={index}>
                <span style={{ fontWeight: 'bold' }}>ID: {item.highwayLineId}</span>
                <br/>
                <button  class='buttonIsEditDialog' style={{width: '80px'}}  onClick={() => deletePillarCable(id, item.highwayLineId)}> Удалить</button> 
              </div>
            )
          ))}
        </div>
      )}
    </div>
  );
};
export default DeletePillarConnection;